APP_CONTAINER_VERSION = '16.0.0';
APP_CORE_VERSION = '16.0.0';
APP_CONTAINER_NAME = 'self-revolving-fe';
APP_CORE_NAME = 'self-digital-core-fe';
